import { render, staticRenderFns } from "./AdminContentCampaignCollectionRow.vue?vue&type=template&id=0d53f9d6&"
import script from "./AdminContentCampaignCollectionRow.vue?vue&type=script&lang=ts&"
export * from "./AdminContentCampaignCollectionRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTd});
